module.exports = __webpack_public_path__ + "img/tema-3-23.7f309013.png";